import { render, staticRenderFns } from "./SearchSNP.vue?vue&type=template&id=6928c183&"
import script from "./SearchSNP.vue?vue&type=script&lang=js&"
export * from "./SearchSNP.vue?vue&type=script&lang=js&"
import style0 from "./SearchSNP.vue?vue&type=style&index=0&id=6928c183&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports